export default function Wordmark() {
  return (
    <div>
      <p className="text-heading font-bold tracking-tight text-navy">MerchantView</p>
      <div className="mt-1 h-0.5 w-10 bg-wheat" aria-hidden="true" />
    </div>
  );
}
